// extracted by mini-css-extract-plugin
export default {"user-widget":"user-widget--22SHf"};